import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/contact";


class ContactService {

  searchContacts(search:string){
    return axios
      .post(API_URL + '/search', {search:search})
      .then(response => {
        return response.data;
      });
  }
    
  contactsList(contractor_id:number){
    return axios
      .post(API_URL + '/getlist', {contractor_id:contractor_id})
      .then(response => {
        return response.data;
      });
  }

    deleteContact(contactId:number) {
        //console.log(query)
        return axios
        .delete(API_URL + '/'+contactId)
        .then(response => {
            return response.data;
        });
    }

  
    editContact(data:any) {
        return axios
          .put(API_URL , data)
          .then(response => {
            return response;
          });
    }

    
   getContacts(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        
        return response.data;
      });
  }

  addContact(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }

  getmails(id_list:string){
    return axios
      .post(API_URL + '/getmails', {id_list:id_list})
      .then(response => {
        return response.data;
      });
  }

    
}

export default new ContactService();